import { render, staticRenderFns } from "./NeutronStarViz.vue?vue&type=template&id=64600d0e&scoped=true"
import script from "./NeutronStarViz.vue?vue&type=script&lang=js"
export * from "./NeutronStarViz.vue?vue&type=script&lang=js"
import style0 from "./NeutronStarViz.vue?vue&type=style&index=0&id=64600d0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64600d0e",
  null
  
)

export default component.exports